import request from './http'

//PI周期顶指标
export function takePiCycleTopIndicator(data) {
  return request({
    url: `/marketall/btc/v2/PiCycleTopIndicator`,
    method: 'post',
    data
  })
}

//稳定币供应比
export function takeSsr(data) {
  return request({
    url: `/marketall/btc/v2/ssr`,
    method: 'post',
    data
  })
}

//稳定币供应比振荡器
export function takeSsro(data) {
  return request({
    url: `/marketall/btc/v2/ssro`,
    method: 'post',
    data
  })
}


//库存/新发行比
export function takeStfRatio(data) {
  return request({
    url: `/marketall/btc/v2/stfRatio`,
    method: 'post',
    data
  })
}

//库存/新发行偏差
export function takeStfDeflection(data) {
  return request({
    url: `/marketall/btc/v2/stfDeflection`,
    method: 'post',
    data
  })
}

//黄金比例乘数
export function takeGoldenRatioMult(data) {
  return request({
    url: `/marketall/btc/v2/goldenRatioMult`,
    method: 'post',
    data
  })
}

//PI周期顶指标 eth 
export function takepiCycleTopEth(data) {
  return request({
    url: `/marketall/eth/v2/PiCycleTopIndicator`,
    method: 'post',
    data
  })
}


//黄金比例乘数 eth takegoldenRatioMultEth
export function takegoldenRatioMultEth(data) {
  return request({
    url: `/marketall/eth/v2/goldenRatioMult`,
    method: 'post',
    data
  })
}
//币天销毁量 eth cdd
export function getCddEth(data) {
  return request({
    url: `/marketall/eth/v2/cdd`,
    method: 'post',
    data
  })
}

//已花费输出休眠平均天数 eth dormancy
export function getDormancyEth(data) {
  return request({
    url: `/marketall/eth/v2/dormancy`,
    method: 'post',
    data
  })
}
//已花费输出平均寿命eth asol
export function getAsolEth(data) {
  return request({
    url: `/marketall/eth/v2/asol`,
    method: 'post',
    data
  })
}

//币天销毁量分布eth 
export function getCddwaveEth(data) {
  return request({
    url: `/marketall/eth/v2/cddwave`,
    method: 'post',
    data
  })
}

//按余额分段的地址数分布eth 
export function getDistributionEth(data) {
  return request({
    url: `/marketall/eth/v2/address/distribution`,
    method: 'post',
    data
  })
}

//持有者地址的供应分布eth 
export function getSupplyDistributionEth(data) {
  return request({
    url: `/marketall/eth/v2/address/supplyDistribution`,
    method: 'post',
    data
  })
}

//盈利地址百分比eth 
export function getProfitPercentEth(data) {
  return request({
    url: `/marketall/eth/v2/address/profitPercent`,
    method: 'post',
    data
  })
}

//盈利地址百分比eth 
export function getProfitEth(data) {
  return request({
    url: `/marketall/eth/v2/address/profit`,
    method: 'post',
    data
  })
}

//亏损地址数eth 
export function getLossEth(data) {
  return request({
    url: `/marketall/eth/v2/address/loss`,
    method: 'post',
    data
  })
}

//通货膨胀率eth 
export function getInflactionRateEth(data) {
  return request({
    url: `/marketall/eth/v2/inflactionRate`,
    method: 'post',
    data
  })
}

//通货膨胀率eth 
export function getIssuanceEth(data) {
  return request({
    url: `/marketall/eth/v2/issuance`,
    method: 'post',
    data
  })
}

//已花费输出盈利比eth 
export function getSoprEth(data) {
  return request({
    url: `/marketall/eth/v2/sopr`,
    method: 'post',
    data
  })
}

//流通速度eth 
export function getVelocityEth(data) {
  return request({
    url: `/marketall/eth/v2/velocity`,
    method: 'post',
    data
  })
}

//流通速度eth 
export function getNvtRatioEth(data) {
  return request({
    url: `/marketall/eth/v2/nvtRatio`,
    method: 'post',
    data
  })
}

//活跃度eth 
export function getLivelinessEth(data) {
  return request({
    url: `/marketall/eth/v2/liveliness`,
    method: 'post',
    data
  })
}

//交易费率乘数eth 
export function getFrmEth(data) {
  return request({
    url: `/marketall/eth/v2/frm`,
    method: 'post',
    data
  })
}

//盈利百分比eth 
export function getSupplyProfitPercentEth(data) {
  return request({
    url: `/marketall/eth/v2/supply/profitPercent`,
    method: 'post',
    data
  })
}

//盈利供应量eth 
export function getSupplyProfitEth(data) {
  return request({
    url: `/marketall/eth/v2/supply/profit`,
    method: 'post',
    data
  })
}

//盈利亏损量eth 
export function getSupplyLossEth(data) {
  return request({
    url: `/marketall/eth/v2/supply/loss`,
    method: 'post',
    data
  })
}

//未实现的净收益损失比eth 
export function getNuplEth(data) {
  return request({
    url: `/marketall/eth/v2/nupl`,
    method: 'post',
    data
  })
}

//未实现的净收益量 eth 
export function getRelativeUProfitEth(data) {
  return request({
    url: `/marketall/eth/v2/relativeUProfit`,
    method: 'post',
    data
  })
}

//未实现的净亏损量 eth 
export function getRelativeULossEth(data) {
  return request({
    url: `/marketall/eth/v2/relativeULoss`,
    method: 'post',
    data
  })
}

//长持者未实现的净收益量 eth 
export function getLthNUPLEth(data) {
  return request({
    url: `/marketall/eth/v2/lthNUPL`,
    method: 'post',
    data
  })
}

//短持者未实现的净亏损量 eth 
export function getSthNUPLEth(data) {
  return request({
    url: `/marketall/eth/v2/sthNUPL`,
    method: 'post',
    data
  })
}

//流通市值 eth 
export function getMarketcapEth(data) {
  return request({
    url: `/marketall/eth/v2/marketcap`,
    method: 'post',
    data
  })
}

//已实现流通市值 eth 
export function getRcapEth(data) {
  return request({
    url: `/marketall/eth/v2/rcap`,
    method: 'post',
    data
  })
}

//已实现价格 eth 
export function getRpriceEth(data) {
  return request({
    url: `/marketall/eth/v2/rprice`,
    method: 'post',
    data
  })
}

//流通市值-已实现流通市值比 eth 
export function getMvrvRatioEth(data) {
  return request({
    url: `/marketall/eth/v2/mvrvRatio`,
    method: 'post',
    data
  })
}

//燃烧量 eth 
export function getBurnedSupplyEth(data) {
  return request({
    url: `/marketall/eth/v2/burnedSupply`,
    method: 'post',
    data
  })
}

//燃烧量 eth 
export function getMintedSupplyEth(data) {
  return request({
    url: `/marketall/eth/v2/mintedSupply`,
    method: 'post',
    data
  })
}

//USDT铸造量
export function getMintedUSDT(data) {
  return request({
    url: `/marketall/eth/v2/usdt/minted`,
    method: 'post',
    data
  })
}
//USDT铸造量 表格数据
export function getMintedUSDTTable(data) {
  return request({
    url: `/marketall/eth/v2/usdt/minted/list`,
    method: 'post',
    data
  })
}
//USDC铸造量
export function getMintedUSDC(data) {
  return request({
    url: `/marketall/eth/v2/usdc/minted`,
    method: 'post',
    data
  })
}
//USDC铸造量 表格数据
export function getMintedUSDCTable(data) {
  return request({
    url: `/marketall/eth/v2/usdc/minted/list`,
    method: 'post',
    data
  })
}

//BUSD铸造量
export function getMintedBUSD(data) {
  return request({
    url: `/marketall/eth/v2/busd/minted`,
    method: 'post',
    data
  })
}
//BUSD铸造量 表格数据
export function getMintedBUSDTable(data) {
  return request({
    url: `/marketall/eth/v2/busd/minted/list`,
    method: 'post',
    data
  })
}

//资金费率
export function getFundingRate(data) {
  return request({
    url: `/marketall/exchange/fundingRate`,
    method: 'post',
    data
  })
}

//未平仓合约数
export function getOpenInterest(data) {
  return request({
    url: `/marketall/exchange/openInterest`,
    method: 'post',
    data
  })
}


//合约主动买入量
export function getTakerLongShortRatio(data) {
  return request({
    url: `/marketall/exchange/takerlongshortRatio`,
    method: 'post',
    data
  })
}

//成交量分布图
export function getVolumeProfile(data) {
  return request({
    url: `/marketall/exchange/volumeProfile`,
    method: 'post',
    data
  })
}


//成交量分布图 K线数据
export function getKLine(data) {
  return request({
    url: `/marketall/bian/kline`,
    method: 'post',
    data
  })
}

//代币交易量
export function getErcVolume(data) {
  return request({
    url: `/marketall/eth/ETHTokenVolume`,
    method: 'post',
    data
  })
}

//国债收益率
export function getUSTreasuriesYields(data) {
  return request({
    url: `/marketall/market/USTreasuriesYields`,
    method: 'post',
    data
  })
}
//货币供应量
export function MoneyStockMeasures(data) {
  return request({
    url: `/marketall/market/MoneyStockMeasures`,
    method: 'post',
    data
  })
}

//私营部门贷款
export function loanPsi(data) {
  return request({
    url: `/marketall/market/loan/psi`,
    method: 'post',
    data
  })
}

//私人债务占GDP比重
export function loanGdp(data) {
  return request({
    url: `/marketall/market/loan/gdp`,
    method: 'post',
    data
  })
}

//每周经济指数
export function wei(data) {
  return request({
    url: `/marketall/market/wei`,
    method: 'post',
    data
  })
}

//MVRV Z-Score BTC 修改接口为POST
export function MVRVZ(data) {
  return request({
    url: `/marketall/btc/mvrvz`,
    method: 'post',
    data
  })
}


//外汇
export function exchangeRate(data) {
  return request({
    url: `/marketall/market/exchangeRate`,
    method: 'post',
    data
  })
}

//外汇曲线图
export function exchangeRateChart(data) {
  return request({
    url: `/marketall/market/exchangeRate/list`,
    method: 'post',
    data
  })
}

//GDP 曲线图
export function getGDPChart(data) {
  return request({
    url: `/marketall/market/GDP/list`,
    method: 'post',
    data
  })
}

//GDP
export function getGDP(data) {
  return request({
    url: `/marketall/market/GDP`,
    method: 'post',
    data
  })
}





